"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OcrService = void 0;
var OcrService;
(function (OcrService) {
    OcrService["PLATE_RECOGNIZER"] = "PlateRecognizer";
})(OcrService = exports.OcrService || (exports.OcrService = {}));
